
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.696 3.304a4.453 4.453 0 00-6.298 0L9.676 7.026c-1.799 1.8-1.632 4.665 0 6.298.274.273.576.496.895.68l.68-.68c.445-.446.288-.967.28-1.342a2.146 2.146 0 01-.28-.232c-.838-.838-.876-2.274 0-3.15l3.721-3.721a2.229 2.229 0 013.15 0c.868.868.868 2.28 0 3.149l-2.46 2.46c.07.393.497 1.326.278 2.864.01-.01.023-.017.034-.028l3.722-3.722a4.453 4.453 0 000-6.298z"}}),_c('path',{attrs:{"d":"M13.612 9.387a4.238 4.238 0 00-.895-.679l-.68.68c-.445.445-.288.966-.28 1.342.098.069.193.144.28.232.839.837.876 2.273 0 3.149l-4.01 4.01a2.229 2.229 0 01-3.148 0 2.229 2.229 0 010-3.149l2.748-2.749c-.07-.393-.498-1.326-.278-2.864-.01.01-.024.018-.034.028l-4.01 4.01a4.453 4.453 0 006.297 6.298l4.01-4.01c1.766-1.766 1.67-4.629 0-6.298z"}})])
          )
        }
      }
    